import { put } from "redux-saga/effects";
import { GetDocForm } from "../../Services";

export function* getDocForm(action) {
  const payload = action.payload;
  try {
    const res = yield GetDocForm(payload);

    if (res.data.code === "000") {
      yield put({ type: "REQ_FORM_SUCCESS", data: res.data });
    } else {
      yield put({ type: "REQ_FORM_FAILED", errData: res.data });
    }
  } catch (e) {
    yield put({ type: "REQ_FORM_FAILED", errData: e });
  }
}
